import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Home() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [currentBanner, setCurrentBanner] = useState(0);
  
  const banners = [
    {
      id: 1,
      image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Asian%20child%20aged%208-12%20years%20old%20wearing%20clear%20invisible%20orthodontic%20aligners%2C%20showing%20a%20confident%20bright%20smile%20with%20perfect%20teeth%2C%20soft%20natural%20lighting%20from%20the%20left%20side%2C%20clean%20minimalist%20gradient%20background%20transitioning%20from%20soft%20blue%20to%20white%2C%20professional%20medical%20photography%20style%2C%20high%20resolution%2C%20warm%20and%20friendly%20atmosphere%2C%20the%20child%20looks%20happy%20and%20comfortable&width=1920&height=1080&seq=heromain1&orientation=landscape',
      title: '重塑微笑',
      subtitle: '预见未来',
      description: '专为儿童设计的隐形矫治方案\n舒适、安全、高效'
    },
    {
      id: 2,
      image: 'https://readdy.ai/api/search-image?query=Happy%20Asian%20child%20aged%2010%20years%20old%20with%20beautiful%20straight%20teeth%20after%20orthodontic%20treatment%2C%20playing%20outdoors%20with%20friends%2C%20natural%20sunlight%2C%20joyful%20expression%2C%20clean%20gradient%20background%20from%20light%20blue%20to%20white%2C%20professional%20lifestyle%20photography%2C%20high%20resolution%2C%20warm%20and%20positive%20atmosphere&width=1920&height=1080&seq=heromain2&orientation=landscape',
      title: '科技守护',
      subtitle: '健康成长',
      description: 'AI数字化定制方案\n精准、温和、有效'
    },
    {
      id: 3,
      image: 'https://readdy.ai/api/search-image?query=Asian%20child%20aged%209%20years%20old%20confidently%20smiling%20showing%20clear%20aligners%2C%20professional%20dental%20clinic%20environment%2C%20soft%20medical%20lighting%2C%20clean%20gradient%20background%20from%20soft%20teal%20to%20white%2C%20professional%20medical%20photography%20style%2C%20high%20resolution%2C%20trustworthy%20and%20professional%20atmosphere&width=1920&height=1080&seq=heromain3&orientation=landscape',
      title: '专业认证',
      subtitle: '值得信赖',
      description: '全国数百家合作诊所\n认证医生全程指导'
    }
  ];
  
  const cases = [
    {
      id: 1,
      age: '8岁',
      issue: '牙列拥挤',
      duration: '12个月',
      aligners: 24,
      before: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20child%20aged%208%20years%20old%20showing%20crowded%20teeth%20before%20orthodontic%20treatment%2C%20close-up%20dental%20photography%20with%20professional%20medical%20lighting%2C%20clean%20white%20clinical%20background%2C%20high%20resolution%20medical%20documentation%20style%2C%20natural%20skin%20tones%2C%20professional%20dental%20photography&width=400&height=400&seq=case1before&orientation=squarish',
      after: 'https://readdy.ai/api/search-image?query=The%20same%20young%20Asian%20child%20aged%208%20years%20old%20showing%20perfectly%20aligned%20straight%20teeth%20after%20orthodontic%20treatment%2C%20bright%20confident%20smile%2C%20close-up%20dental%20photography%20with%20professional%20medical%20lighting%2C%20clean%20white%20clinical%20background%2C%20high%20resolution%20medical%20documentation%20style%2C%20natural%20skin%20tones%2C%20professional%20dental%20photography&width=400&height=400&seq=case1after&orientation=squarish'
    },
    {
      id: 2,
      age: '10岁',
      issue: '地包天',
      duration: '18个月',
      aligners: 32,
      before: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20child%20aged%2010%20years%20old%20with%20underbite%20dental%20condition%20before%20treatment%2C%20close-up%20dental%20photography%20with%20professional%20medical%20lighting%2C%20clean%20white%20clinical%20background%2C%20high%20resolution%20medical%20documentation%20style%2C%20natural%20skin%20tones%2C%20professional%20dental%20photography&width=400&height=400&seq=case2before&orientation=squarish',
      after: 'https://readdy.ai/api/search-image?query=The%20same%20young%20Asian%20child%20aged%2010%20years%20old%20with%20corrected%20bite%20and%20beautiful%20smile%20after%20orthodontic%20treatment%2C%20close-up%20dental%20photography%20with%20professional%20medical%20lighting%2C%20clean%20white%20clinical%20background%2C%20high%20resolution%20medical%20documentation%20style%2C%20natural%20skin%20tones%2C%20professional%20dental%20photography&width=400&height=400&seq=case2after&orientation=squarish'
    },
    {
      id: 3,
      age: '11岁',
      issue: '深覆合',
      duration: '15个月',
      aligners: 28,
      before: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20child%20aged%2011%20years%20old%20with%20deep%20overbite%20dental%20condition%20before%20treatment%2C%20close-up%20dental%20photography%20with%20professional%20medical%20lighting%2C%20clean%20white%20clinical%20background%2C%20high%20resolution%20medical%20documentation%20style%2C%20natural%20skin%20tones%2C%20professional%20dental%20photography&width=400&height=400&seq=case3before&orientation=squarish',
      after: 'https://readdy.ai/api/search-image?query=The%20same%20young%20Asian%20child%20aged%2011%20years%20old%20with%20corrected%20bite%20alignment%20and%20confident%20smile%20after%20orthodontic%20treatment%2C%20close-up%20dental%20photography%20with%20professional%20medical%20lighting%2C%20clean%20white%20clinical%20background%2C%20high%20resolution%20medical%20documentation%20style%2C%20natural%20skin%20tones%2C%20professional%20dental%20photography&width=400&height=400&seq=case3after&orientation=squarish'
    }
  ];

  // Auto-play banner carousel
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentBanner((prev) => (prev + 1) % banners.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % cases.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + cases.length) % cases.length);
  };

  const nextBanner = () => {
    setCurrentBanner((prev) => (prev + 1) % banners.length);
  };

  const prevBanner = () => {
    setCurrentBanner((prev) => (prev - 1 + banners.length) % banners.length);
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section with Banner Carousel */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        {banners.map((banner, index) => (
          <div
            key={banner.id}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentBanner ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <div 
              className="absolute inset-0 bg-cover bg-center"
              style={{ backgroundImage: `url('${banner.image}')` }}
            >
              <div className="absolute inset-0 bg-gradient-to-r from-blue-900/70 to-transparent"></div>
            </div>
          </div>
        ))}
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-white w-full">
          <div className="max-w-2xl">
            <h1 className="text-6xl font-bold mb-6 leading-tight">
              {banners[currentBanner].title}<br />{banners[currentBanner].subtitle}
            </h1>
            <p className="text-2xl mb-8 text-blue-100 whitespace-pre-line">
              {banners[currentBanner].description}
            </p>
            <div className="flex gap-4">
              <Link 
                to="/find-doctor" 
                className="whitespace-nowrap bg-gradient-to-r from-orange-400 to-orange-500 hover:from-orange-500 hover:to-orange-600 text-white px-8 py-4 rounded-full text-lg font-semibold transition-all shadow-lg hover:shadow-xl cursor-pointer"
              >
                寻找身边的医生
              </Link>
              <Link 
                to="/for-doctors" 
                className="whitespace-nowrap bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white px-8 py-4 rounded-full text-lg font-semibold border-2 border-white/30 transition-all cursor-pointer"
              >
                医生加入
              </Link>
            </div>
          </div>
        </div>

        {/* Banner Navigation Arrows */}
        <button 
          onClick={prevBanner}
          className="absolute left-6 top-1/2 -translate-y-1/2 z-20 w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/30 transition-colors cursor-pointer"
        >
          <i className="ri-arrow-left-s-line text-3xl text-white"></i>
        </button>
        
        <button 
          onClick={nextBanner}
          className="absolute right-6 top-1/2 -translate-y-1/2 z-20 w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/30 transition-colors cursor-pointer"
        >
          <i className="ri-arrow-right-s-line text-3xl text-white"></i>
        </button>

        {/* Banner Indicators */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex gap-2">
          {banners.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentBanner(index)}
              className={`h-2 rounded-full transition-all cursor-pointer ${
                index === currentBanner ? 'bg-white w-8' : 'bg-white/50 w-2'
              }`}
            />
          ))}
        </div>
      </section>

      {/* Core Advantages */}
      <section className="py-20 bg-gradient-to-b from-white to-blue-50">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-center mb-16 text-gray-800">为什么选择 Mirókids</h2>
          <div className="grid md:grid-cols-4 gap-8">
            <div className="text-center group">
              <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-blue-400 to-blue-600 rounded-2xl flex items-center justify-center transform group-hover:scale-110 transition-transform">
                <i className="ri-shield-check-line text-4xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">舒适隐形</h3>
              <p className="text-gray-600 leading-relaxed">采用医用级高分子材料，轻薄透明，佩戴舒适无异物感</p>
            </div>
            
            <div className="text-center group">
              <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-orange-400 to-orange-600 rounded-2xl flex items-center justify-center transform group-hover:scale-110 transition-transform">
                <i className="ri-cpu-line text-4xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">AI数字化定制</h3>
              <p className="text-gray-600 leading-relaxed">智能排牙系统精准设计，每副牙套都为孩子量身定制</p>
            </div>
            
            <div className="text-center group">
              <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-pink-400 to-pink-600 rounded-2xl flex items-center justify-center transform group-hover:scale-110 transition-transform">
                <i className="ri-heart-pulse-line text-4xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">专为儿童设计</h3>
              <p className="text-gray-600 leading-relaxed">针对6-12岁儿童口腔特点，温和矫正不影响生长发育</p>
            </div>
            
            <div className="text-center group">
              <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-green-400 to-green-600 rounded-2xl flex items-center justify-center transform group-hover:scale-110 transition-transform">
                <i className="ri-user-star-line text-4xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">专业医生团队</h3>
              <p className="text-gray-600 leading-relaxed">全国数百家合作诊所，认证正畸医生全程跟踪指导</p>
            </div>
          </div>
        </div>
      </section>

      {/* Treatment Process */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-center mb-16 text-gray-800">矫治流程</h2>
          <div className="relative">
            <div className="absolute top-1/2 left-0 right-0 h-1 bg-gradient-to-r from-blue-200 via-blue-400 to-blue-200 transform -translate-y-1/2 hidden md:block"></div>
            
            <div className="grid md:grid-cols-5 gap-8 relative">
              {[
                { icon: 'ri-scan-line', title: '扫描取模', desc: '3D口扫仪快速采集口腔数据' },
                { icon: 'ri-palette-line', title: '方案设计', desc: 'AI智能排牙生成矫治方案' },
                { icon: 'ri-box-3-line', title: '佩戴矫治器', desc: '收到定制牙套开始佩戴' },
                { icon: 'ri-calendar-check-line', title: '定期复诊', desc: '每4-6周复诊更换牙套' },
                { icon: 'ri-trophy-line', title: '完成治疗', desc: '获得整齐健康的牙齿' }
              ].map((step, index) => (
                <div key={index} className="text-center relative">
                  <div className="w-24 h-24 mx-auto mb-4 bg-white rounded-full flex items-center justify-center shadow-lg border-4 border-blue-100 relative z-10">
                    <i className={`${step.icon} text-4xl text-blue-600`}></i>
                  </div>
                  <div className="absolute top-10 left-1/2 transform -translate-x-1/2 w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold z-20 shadow-md">
                    {index + 1}
                  </div>
                  <h3 className="text-lg font-bold mb-2 text-gray-800">{step.title}</h3>
                  <p className="text-sm text-gray-600">{step.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Success Cases Carousel */}
      <section className="py-20 bg-gradient-to-b from-blue-50 to-white">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-center mb-4 text-gray-800">成功案例</h2>
          <p className="text-center text-gray-600 mb-12">见证每一个孩子的微笑蜕变</p>
          
          <div className="relative max-w-4xl mx-auto">
            <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-12">
              <div className="grid md:grid-cols-2 gap-8 items-center">
                <div className="space-y-4">
                  <div className="relative group">
                    <div className="absolute inset-0 bg-gradient-to-br from-red-400 to-red-600 rounded-2xl transform rotate-3 group-hover:rotate-6 transition-transform"></div>
                    <img 
                      src={cases[currentSlide].before} 
                      alt="治疗前"
                      className="relative rounded-2xl w-full h-80 object-cover shadow-lg"
                    />
                    <div className="absolute bottom-4 left-4 bg-red-500 text-white px-4 py-2 rounded-full font-semibold">
                      治疗前
                    </div>
                  </div>
                </div>
                
                <div className="space-y-4">
                  <div className="relative group">
                    <div className="absolute inset-0 bg-gradient-to-br from-green-400 to-green-600 rounded-2xl transform -rotate-3 group-hover:-rotate-6 transition-transform"></div>
                    <img 
                      src={cases[currentSlide].after} 
                      alt="治疗后"
                      className="relative rounded-2xl w-full h-80 object-cover shadow-lg"
                    />
                    <div className="absolute bottom-4 right-4 bg-green-500 text-white px-4 py-2 rounded-full font-semibold">
                      治疗后
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="mt-8 text-center">
                <div className="inline-flex items-center gap-6 bg-blue-50 px-8 py-4 rounded-full">
                  <div>
                    <div className="text-sm text-gray-600">年龄</div>
                    <div className="text-lg font-bold text-blue-600">{cases[currentSlide].age}</div>
                  </div>
                  <div className="w-px h-10 bg-gray-300"></div>
                  <div>
                    <div className="text-sm text-gray-600">症状</div>
                    <div className="text-lg font-bold text-blue-600">{cases[currentSlide].issue}</div>
                  </div>
                  <div className="w-px h-10 bg-gray-300"></div>
                  <div>
                    <div className="text-sm text-gray-600">疗程</div>
                    <div className="text-lg font-bold text-blue-600">{cases[currentSlide].duration}</div>
                  </div>
                  <div className="w-px h-10 bg-gray-300"></div>
                  <div>
                    <div className="text-sm text-gray-600">牙套数量</div>
                    <div className="text-lg font-bold text-blue-600">{cases[currentSlide].aligners}副</div>
                  </div>
                </div>
              </div>
            </div>
            
            <button 
              onClick={prevSlide}
              className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-6 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-blue-50 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-2xl text-blue-600"></i>
            </button>
            
            <button 
              onClick={nextSlide}
              className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-6 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-blue-50 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-2xl text-blue-600"></i>
            </button>
            
            <div className="flex justify-center gap-2 mt-8">
              {cases.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentSlide(index)}
                  className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
                    index === currentSlide ? 'bg-blue-600 w-8' : 'bg-gray-300'
                  }`}
                />
              ))}
            </div>
          </div>
          
          <div className="text-center mt-12">
            <Link 
              to="/cases" 
              className="whitespace-nowrap inline-block bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-full font-semibold transition-colors cursor-pointer"
            >
              查看更多案例
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-blue-600 to-blue-800 text-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold mb-6">开启孩子的自信微笑之旅</h2>
          <p className="text-xl mb-8 text-blue-100">专业医生就在您身边，立即预约免费咨询</p>
          <Link 
            to="/find-doctor" 
            className="whitespace-nowrap inline-block bg-white text-blue-600 hover:bg-blue-50 px-10 py-4 rounded-full text-lg font-bold transition-colors shadow-lg cursor-pointer"
          >
            立即寻找医生
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}